<div class="row">
  <div class="col-6 secondary-details">
    <span> {{ 'address.addressList.addressListTitle' | translate }} </span>
  </div>
  <div class="col-6 text-end">
    <button
      class="me-1 icon-mat-header"
      (click)="openCreateAddress()"
      #tooltip="matTooltip"
      matTooltip="{{ 'address.addressList.toolTip.createAddress' | translate }}"
      mat-raised-button>
      <em class="bi bi-plus"></em>
    </button>

    <button
      *ngIf="deleteDisable"
      class="me-1 icon-mat-header"
      (click)="getHeaderForAddressDownload()"
      #tooltip="matTooltip"
      matTooltip="{{ 'address.addressList.toolTip.downloadAddressTemplate' | translate }}"
      mat-raised-button>
      <em class="bi bi-filetype-csv"></em>
    </button>

    <button
      *ngIf="deleteDisable"
      class="me-1 icon-mat-header"
      (click)="openUploadAddress()"
      #tooltip="matTooltip"
      matTooltip="{{ 'address.addressList.toolTip.uploadAddress' | translate }}"
      mat-raised-button>
      <em class="bi bi-upload"></em>
    </button>

    <button
      *ngIf="selectedAddress.length > 0 && this.selectedTabForStatus !== 2"
      class="me-1 icon-mat-header float-right"
      [disabled]="deleteDisable"
      (click)="deleteAddress(this.selectedAddress)"
      matTooltip="{{ 'address.addressList.toolTip.delete' | translate }}"
      mat-raised-button>
      <i class="bi bi-trash"></i>
    </button>
  </div>
</div>

<div class="row">
  <div class="col-sm-6 ml-2 mt-2 search-bar-group">
    <input
      matInput
      class="pt-2 input-search"
      [formControl]="searchKeywordFilter"
      placeholder="{{ 'address.addressList.searchAddress' | translate }}" />
  </div>
</div>

<div class="row">
  <div class="col-12">
    <mat-tab-group
      mat-align-tabs="start"
      [(selectedIndex)]="selectedTabForStatus"
      (selectedTabChange)="onStatusTabChange($event)">
      <mat-tab label="Shipper">
        <ng-template mat-tab-label>
          <span> {{ 'address.addressList.shipper' | translate }}</span>
        </ng-template>
      </mat-tab>
      <mat-tab label="Receiver">
        <ng-template mat-tab-label>
          <span> {{ 'address.addressList.receiver' | translate }}</span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div class="custom-card">
  <div class="col-sm-12 table-container">
    <table
      aria-label="addresslist"
      mat-table
      matSort
      matSortDirection="desc"
      [dataSource]="dataSource">
      <ng-container matColumnDef="addressSelected">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            *ngIf="this.selectedTabForStatus !== 2"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isEntirePageSelected()"
            [indeterminate]="selection.hasValue() && !isEntirePageSelected()"></mat-checkbox>
        </th>

        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            *ngIf="this.selectedTabForStatus !== 2"
            [checked]="selection.isSelected(element)"
            (change)="selection.toggle(element); updateSelection()"
            class="pt-2"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="NickName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.nickName' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.nickName }}</td>
      </ng-container>
      <ng-container matColumnDef="CompanyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.companyName' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.companyName }}</td>
      </ng-container>
      <ng-container matColumnDef="ContactPersonName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.contactPerson' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.contactPersonName }}</td>
      </ng-container>
      <ng-container matColumnDef="AddressLine1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.addressLine1' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.addressLine1 }}</td>
      </ng-container>
      <ng-container matColumnDef="CityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.city' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.cityName }}</td>
      </ng-container>
      <ng-container matColumnDef="PostalCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.postalCode' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.postalCode }}</td>
      </ng-container>
      <ng-container matColumnDef="CountryCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.countryCode' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.countryCode }}</td>
      </ng-container>
      <ng-container matColumnDef="addressValidated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.status' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.addressStatus }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'address.addressList.action' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="row" *ngIf="openedFrom === ('shipper' || 'receiver')">
            <em
              class="bi bi-check-square"
              (click)="getAddress(row)"
              [ngClass]="{
                'selected-address': selectedRow === row?.address_id,
                'icon-mat': selectedRow != row?.address_id
              }"
              #tooltip="matTooltip"
              matTooltip="Confirm"></em>
          </div>
          <div class="row" *ngIf="!openedFrom">
            <a class="btn bg-transparent col-8" data-toggle="tooltip" title=" {{ 'address.addressList.toolTip.edit' | translate }}">
              <i class="icon-mat bi bi-pen" (click)="openDialogEdit(row?.address_id, row?._id)"></i>
            </a>
            <!-- <a class="btn bg-transparent col-3" data-toggle="tooltip" title="Delete">
                <i class="icon-mat bi bi-trash" (click)="openDialogDelete(row.address_id)"></i>
            </a> -->
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="cursor-pointer"></tr>
    </table>
    <mat-paginator
      [pageSize]="15"
      #paginator
      [length]="totalData"
      [pageSizeOptions]="pageSizes"
      showFirstLastButtons></mat-paginator>
  </div>
</div>
